<template>
    <div>
        <h2>Review &amp; submit</h2>

        <div class="signup-form__data-wrapper">
            <p class="signup-form__header">Contact</p>
            <div class="signup-form__data">
                <p>{{ state.form.name }}</p>
                <p>{{ state.form.email }}</p>
                <p>{{ state.form.phone }}</p>
            </div>
        </div>

        <div class="signup-form__data-wrapper">
            <p class="signup-form__header">Brokerage</p>
            <p>
                {{ state.form.brokerage }}<br />
                Principal: {{ state.form.principalBrokerName }} &lt;{{ state.form.principalBrokerEmail }}&gt;
                <template v-if="state.form.website"> <br />Website: {{ state.form.website }} </template>
                <template v-if="!buildingForThem && state.form.websiteBuilder">
                    <br />Builder: {{ websiteBuilderLabel
                    }}<template v-if="state.form.websiteBuilder === 'other' && state.form.websiteBuilderOther">
                        ({{ state.form.websiteBuilderOther }})</template
                    >
                </template>
            </p>
        </div>

        <div class="signup-form__data-wrapper">
            <p class="signup-form__header">Plan</p>
            <p>{{ planLabel }}</p>
        </div>

        <div class="signup-form__data-wrapper">
            <p class="signup-form__header">Selected MLS Associations</p>
            <ul>
                <li v-for="assoc in selectedAssociations" :key="assoc.id">
                    {{ assoc.name }} — agent ID
                    <strong>{{ agentIdFor(assoc.id) }}</strong>
                </li>
                <li v-if="state.form.otherAssociationName">
                    <em>Other:</em> {{ state.form.otherAssociationName }}
                </li>
            </ul>
        </div>

        <div class="signup-form__data-wrapper">
            <label for="signup-notes" class="signup-form__label">Special instructions or questions</label>
            <textarea
                class="signup-form__input signup-form__input--textarea"
                id="signup-notes"
                v-model="state.form.signupNotes"
                rows="4"
            ></textarea>
            <span v-if="error('signupNotes')" class="signup-form__error" role="alert">{{ error('signupNotes') }}</span>
        </div>

        <p v-if="state.submitError" class="signup-banner--error" role="alert">
            {{ state.submitError }}
        </p>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import useState from '@/composables/useState';

const { state } = useState();

const planLabel = computed(() => {
    const plan = state.catalog.plans.find((p) => p.code === state.form.planCode);
    if (!plan) return '(unknown plan)';
    if (state.form.addonCodes.includes('website_builder')) {
        return `${plan.name} + Website Builder`;
    }
    return plan.name;
});

const selectedAssociations = computed(() =>
    state.catalog.associations.filter((a) => state.form.associations.some((s) => s.id === a.id)),
);

const agentIdFor = (id) => state.form.associations.find((a) => a.id === id)?.agentId || '';

const websiteBuilderLabels = {
    wordpress: 'WordPress',
    squarespace: 'Squarespace',
    wix: 'Wix',
    other: 'Other',
};

const websiteBuilderLabel = computed(() => websiteBuilderLabels[state.form.websiteBuilder] || '');

const buildingForThem = computed(() => state.form.addonCodes.includes('website_builder'));

const error = (field) => state.serverErrors[field]?.[0];
</script>
